import { dtcgTokensRaw } from '../dtcg-tokens/tokens-raw.js';

/**
 * @deprecated use the `StyleBreakpoints` typescript type for type safety
 */ const SCREEN_CLASSES = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
/**
 * Map of Screen Classes to their max-pixel-widths
 * @deprecated use exported js tokens directly (ex SizeBreakpointSmEnd)
 */ const SCREEN_CLASS_MAX_WIDTHS = {
    xs: parseInt(dtcgTokensRaw.SwanBaseBreakpointXsEnd, 10),
    sm: parseInt(dtcgTokensRaw.SwanBaseBreakpointSmEnd, 10),
    md: parseInt(dtcgTokensRaw.SwanBaseBreakpointMdEnd, 10),
    lg: parseInt(dtcgTokensRaw.SwanBaseBreakpointLgEnd, 10),
    xl: Infinity
};
/**
 * Map of Screen Classes to their min-pixel-widths
 * @deprecated use exported js tokens directly (ex SizeBreakpointSmStart)
 */ const SCREEN_CLASS_MIN_WIDTHS = {
    xs: parseInt(dtcgTokensRaw.SwanBaseBreakpointXsStart, 10),
    sm: parseInt(dtcgTokensRaw.SwanBaseBreakpointSmStart, 10),
    md: parseInt(dtcgTokensRaw.SwanBaseBreakpointMdStart, 10),
    lg: parseInt(dtcgTokensRaw.SwanBaseBreakpointLgStart, 10),
    xl: parseInt(dtcgTokensRaw.SwanBaseBreakpointXlStart, 10)
};
/**
 * Returns the Screen Class corresponding to the given width
 *
 * @param windowWidth - the width (in px) of the window/screen
 * @deprecated
 */ function getScreenClass(windowWidth) {
    for (const screenClass of SCREEN_CLASSES){
        const maxWidth = SCREEN_CLASS_MAX_WIDTHS[screenClass];
        const minWidth = SCREEN_CLASS_MIN_WIDTHS[screenClass];
        if (windowWidth >= minWidth && windowWidth <= maxWidth) {
            return screenClass;
        }
    }
    // the loop above should be guaranteed to return a value
    // if we hit this error, we messed up
    throw new Error('Misconfigured screen classes.');
}

export { SCREEN_CLASSES, SCREEN_CLASS_MAX_WIDTHS, SCREEN_CLASS_MIN_WIDTHS, getScreenClass };
